import * as yup from 'yup';

export const tiposCadastro = [
    { value: 1, label: 'Assentamento' },
    { value: 2, label: 'Comunidade Quilombola' },
];

export const tiposAssentamento = [
    { value: 3, label: 'FEDERAIS – PA' },
    { value: 4, label: 'FEDERAIS CASULO/PCA (parceria entre INCRA e município)' },
    { value: 5, label: 'ESTADUAIS – PE' },
    { value: 6, label: 'PROJETOS DO TERRA BRASIL/ PROGRAMA NACIONAL DE CRÉDITO FUNDIÁRIO (PNCF)/ BANCO DA TERRA' },
];

export const fontesAgua = [
    { value: 1, label: 'Córrego' },
    { value: 2, label: 'Rio ou outro curso d\'água' },
    { value: 3, label: 'Poço comum' },
    { value: 4, label: 'Poço artesiano ou semi-artesiano' },
    { value: 5, label: 'Captação da chuva' },
    { value: 6, label: 'Água potável de órgão/companhia de abastecimento' },
];


export const validationSchemaComunidades = yup.object().shape({
    tipo_cadastro: yup.number().nullable().required('Tipo de cadastro é obrigatório').oneOf(tiposCadastro.map(tipo => tipo.value), 'Selecione um tipo de cadastro'),
    tipo_de_assentamento: yup.number().when(
        'tipo_cadastro',
        {
            is: 1,
            then: yup.number().required('Tipo de assentamento é obrigatório').oneOf(tiposAssentamento.map(tipo => tipo.value), 'Selecione um tipo de assentamento'),
        }
    ),
    codigo_do_pa: yup.string().when(
        'tipo_cadastro',
        {
            is: 1,
            then: yup.string().required('Código do PA é obrigatório').min(8, 'Código do PA deve ter 8 caracteres').max(8, 'Código do PA deve ter 8 caracteres'),
        }
    ),
    nome_do_assentamento: yup.string().required('Nome do assentamento é obrigatório'),
    quantidade_de_familias: yup.number().required('Quantidade de famílias é obrigatória').min(1, 'Quantidade de famílias deve ser informada'),
    // step 2
    possui_energia_eletrica: yup.boolean().nullable()
        .when(
            'step_atual',
            {
                is: 2,
                then: yup.boolean().nullable()
                    .required('Possui energia elétrica é obrigatório'),
            }
        ),
    possui_saneamento_basico: yup.boolean().nullable()
        .when(
            'step_atual',
            {
                is: 2,
                then: yup.boolean().nullable()
                    .required('Possui saneamento básico é obrigatório'),
            }
        ),
    coleta_de_lixo: yup.boolean().nullable()
        .when(
            'step_atual',
            {
                is: 2,
                then: yup.boolean().nullable()
                    .required('Coleta de lixo é obrigatório'),
            }
        ),
    recebeu_manutencao_das_estradas_no_ultimo_ano: yup.boolean().nullable()
        .when(
            'step_atual',
            {
                is: 2,
                then: yup.boolean().nullable()
                    .required('Recebeu manutenção das estradas no último ano é obrigatório'),
            }
        ),
    possui_escolas: yup.boolean().nullable()
        .when(
            'step_atual',
            {
                is: 2,
                then: yup.boolean().nullable()
                    .required('Possui escolas é obrigatório'),
            }
        ),
    escolas: yup.array().when(
        'step_atual',
        {
            is: 2,
            then: yup.array().when(
                'possui_escolas',
                {
                    is: true,
                    then: yup.array().of(yup.object().shape({
                        nome: yup.string().required('Nome da escola é obrigatório').min(3, 'Nome da escola deve ter no mínimo 3 caracteres'),
                        jurisdicao: yup.string().required('Jurisdição da escola é obrigatória'),
                    })),
                }
            )
        }
    ),
    possui_oferta_de_transporte_escolar_para_os_estudantes: yup.boolean().nullable()
        .when(
            'step_atual',
            {
                is: 2,
                then: yup.boolean().nullable()
                    .required('Possui oferta de transporte escolar para os estudantes é obrigatório'),
            }
        ),
    possui_unidade_de_saude: yup.boolean().nullable()
        .when(
            'step_atual',
            {
                is: 2,
                then: yup.boolean().nullable()
                    .required('Possui unidade de saúde é obrigatório'),
            }
        ),
    recebeu_agentes_de_saude_do_municipio: yup.boolean().nullable()
        .when(
            'step_atual',
            {
                is: 2,
                then: yup.boolean().nullable()
                    .required('Recebeu agentes de saúde do município é obrigatório'),
            }
        ),
    tem_acesso_internet: yup.boolean().nullable()
        .when(
            'step_atual',
            {
                is: 2,
                then: yup.boolean().nullable()
                    .required('Tem acesso à internet é obrigatório'),
            }
        ),
    possui_agua_para_abastecimento_domestico: yup.boolean().nullable()
        .when(
            'step_atual',
            {
                is: 3,
                then: yup.boolean().nullable()
                    .required('Possui água para abastecimento doméstico é obrigatório'),
            }
        ),
    qual_fonte_da_agua_domestico: yup.number().nullable().when(
        'step_atual',
        {
            is: 3,
            then: yup.number().nullable().when(
                'possui_agua_para_abastecimento_domestico',
                {
                    is: true,
                    then: yup.number().required('Qual fonte da água doméstica é obrigatório').oneOf(fontesAgua.map(fonte => fonte.value), 'Selecione uma fonte de água'),
                }
            )
        }
    ),
    possui_agua_para_producao_agropecuaria: yup.boolean().nullable()
        .when(
            'step_atual',
            {
                is: 3,
                then: yup.boolean().nullable()
                    .required('Possui água para produção agropecuária é obrigatório'),
            }
        ),
    qual_fonte_da_producao_agropecuaria: yup.number().nullable().when(
        'step_atual',
        {
            is: 3,
            then: yup.number().nullable().when(
                'possui_agua_para_producao_agropecuaria',
                {
                    is: true,
                    then: yup.number().required('Qual fonte da produção agropecuária é obrigatório').oneOf(fontesAgua.map(fonte => fonte.value), 'Selecione uma fonte de água'),
                }
            )
        }
    ),
    quantas_familia_estao_sem_acesso_agua_domestico: yup.number().when(
        'step_atual',
        {
            is: 3,
            then: yup.number().when(
                'tipo_cadastro',
                {
                    is: 1,
                    then: yup.number().required('Essas informações são obrigatórias para assentamentos'),
                }
            ),
        }
    ),
    quantas_familia_estao_sem_acesso_agua_producao: yup.number().when(
        'step_atual',
        {
            is: 3,
            then: yup.number().when(
                'tipo_cadastro',
                {
                    is: 1,
                    then: yup.number().required('Essas informações são obrigatórias para assentamentos'),
                }
            ),
        }
    ),
    comunidade_quilomba_tem_dificil_acesso_agua_domestico: yup.boolean().nullable()
        .when(
            'step_atual',
            {
                is: 3,
                then: yup.boolean().nullable()
                    .when(
                        'tipo_cadastro',
                        {
                            is: 2,
                            then: yup.boolean().nullable()
                                .required('Essas informações são obrigatórias para comunidades quilombolas'),
                        }
                    ),
            }
        ),
    comunidade_quilomba_tem_dificil_acesso_agua_producao: yup.boolean().nullable()
        .when(
            'step_atual',
            {
                is: 3,
                then: yup.boolean().nullable().when(
                    'tipo_cadastro',
                    {
                        is: 2,
                        then: yup.boolean().nullable()
                            .required('Essas informações são obrigatórias para comunidades quilombolas'),
                    }
                ),
            }
        ),
});